<script setup>
import {defineProps, onMounted, ref} from "vue";

const props = defineProps({
  comment: Object,
  index: Number,
  removeComment: Function
})

onMounted(() => {
  setDraggable("comment_area");
  document.addEventListener('keydown', handleKeyDown);
})

const openPopover = ref(false);
const popoverPosition = ref({left: '0px', top: '0px'});

const fontSizes = [];
for (let i = 4; i <= 72; i++) {
  fontSizes.push(i);
}


function handleKeyDown(e) {
  if (e.key === 'Escape') {
    openPopover.value = false;
  }
}

function showPopover(event) {
  if (!event.target.closest('.popover')) {
    const tdRect = event.currentTarget.getBoundingClientRect();

    const relativeX = event.clientX - tdRect.left;
    const relativeY = event.clientY - tdRect.top;

    popoverPosition.value = {
      left: `${relativeX}px`,
      top: `${relativeY}px`
    };

    openPopover.value = !openPopover.value;
  }
}

const comment_dom = ref(null)


function setDraggable(name) {
  const container = document.getElementById(name);
  const draggable = comment_dom.value
  draggable.addEventListener('mousedown', (e) => {

    const shiftY = e.clientY - draggable.getBoundingClientRect().top;

    function onMouseMove(e) {
      const pageY = e.clientY, containerRect = container.getBoundingClientRect();
      let newY = pageY - shiftY - containerRect.top;
      newY = Math.max(0, Math.min(newY, containerRect.height - draggable.offsetHeight));
      draggable.style.top = `${newY}px`;
      props.comment.top = newY;
    }

    function onMouseHeight(e) {
      const height = e.clientY - draggable.getBoundingClientRect().top + window.scrollY;
      draggable.style.height = `${height}px`;
      props.comment.height = height;
    }

    if (e.target.classList.value !== "resize") {
      document.addEventListener('mousemove', onMouseMove);

      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', onMouseMove);
      }, {once: true});
    } else {
      document.addEventListener('mousemove', onMouseHeight);

      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', onMouseHeight);
      }, {once: true});

    }
  });
}

</script>

<template>
  <div ref="comment_dom" class="comment"
       @click="showPopover($event)"
       :style="{top: comment.top + 'px', height:comment.height + 'px'}">
    <textarea
        :style="{color: comment.style.color, fontSize: comment.style.fontSize, fontWeight: comment.style.bold?700:300}"
        v-model="comment.text"></textarea>
    <div class="resize"></div>
    <div class="delete" @click="removeComment(index)"><i class="bi bi-x"></i></div>
    <div class="popover" v-show="openPopover" :style="popoverPosition">
      <div class="font-size">
        <select name="" v-model="comment.style.fontSize" id="">
          <option v-for="font in fontSizes" :value="`${font}pt`" :key="font">{{ font }}</option>
        </select>
      </div>
      <div class="color">
        <input v-model="comment.style.color" type="color">
      </div>
      <div class="bold">
        <button @click="comment.style.bold = !comment.style.bold"
                :class="`btn btn-sm`+(comment.style.bold?' btn-outline-dark':'')"><b>B</b></button>
      </div>

    </div>

  </div>
</template>

<style scoped lang="scss">
.comment {
  position: absolute;
  width: 100%;

  textarea {
    resize: none !important;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  .delete {
    position: absolute;
    right: 2px;
    top: 2px;
    cursor: pointer;
  }

  .resize {
    position: absolute;
    bottom: -4px;
    width: 16px;
    height: 8px;
    background: #ccc;
    cursor: n-resize;
    margin: 0 auto;
    left: 45%;
  }
}

.popover {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 100;
  display: flex;
  gap: 10px;
  transform: translateY(10px);

  input {
    height: 20px;
  }

  button {
    height: 20px;
    font-size: 12px;
    line-height: 12px;
  }
}

</style>